import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Switch, Tag } from 'antd'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit, BiUser } from 'react-icons/bi'
import { GoTrash } from 'react-icons/go'
import { useDeleteBlogCat, useGetBlogCats, usePostBlogCat, usePutBlogCat } from '../../../hooks/blogs/blogs'

function BlogCatTab() {
  const [createPayload, setCreatePayload] = useState({
    name:"",
    // color:"",
    id:""
  })
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [selected, setSelected] = useState({})
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
    setSelected()
  }
  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setSelected({})
    setRows([])
  }

const {
  data: getBlogCat,
  refetch: getFetch,
  isFetching: getReload,
} = useGetBlogCats()

const successAction = () => {
  getFetch()
  form.resetFields();
  setSelected()
  onCloseEdit()
  onCreateClose()
};

  const handleEdit = (d) => {
    setIsOpenEdit(true)
    setCreatePayload({
      name:d?.name,
      // color:d?.color,
      id:d?.id
    })
  }
  const {
    mutate: postAction,
    isLoading: postLoading,
  } = usePostBlogCat(successAction)
  
  const {
    mutate: putAction,
    isLoading: putLoading,
  } = usePutBlogCat(successAction)

  const {
    mutate: deleteAction,
    isLoading: deleteLoading,
  } = useDeleteBlogCat(successAction)

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key:"name",
      render: (e) => <div className='flex items-center gap-3'>
        {/* <Avatar src="">CF</Avatar> */}
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          {key: "edit", label: <button className='flex' id='' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-2 py-auto' /> Edit</button>},
          {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-2 py-auto' /> Delete</button>},

        ]}}
      >
        <Button loading={deleteLoading} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]
  const onSubmit = (d) => {
    postAction(d)
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
  }
  return (
    <PadContainer loading={getReload}>
      <TitleContainer
        path={false}
        title="Blog Categories"
        className="border border-lit rounded-xl"
        action={<Button onClick={onCreateOpen} className='!bg-light_blue' type='primary' size='large' icon={<FaPlus />}>Add Category</Button>}
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getBlogCat?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Category</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Name" name="name" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input size='large' placeholder='Name' />
          </Form.Item>
          {/* <Form.Item label="Color" name="color" rules={[{required: true, message: 'Please input Color!',},]}>
            <Input size='large' placeholder='Color' />
          </Form.Item> */}
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoading} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Brand</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
          form={form}
        >
          <Form.Item label="Name" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input 
                size='large' 
                placeholder='Edit name' 
                prefix={<BiUser />} 
                value={createPayload.name}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, name: value})}
            />
          </Form.Item>
          {/* <Form.Item label="Color" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input 
                size='large' 
                placeholder='Edit Color' 
                value={createPayload.color}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, color: value})}
            />
          </Form.Item> */}

          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmitEdit} loading={putLoading} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>
    </PadContainer>
  )
}

export default BlogCatTab